import React from 'react';
import {
  View,
  Pressable,
  StyleSheet,
  Image,
  FlatList,
  Dimensions,
  Platform,
  TouchableOpacity,
} from 'react-native';
import { styles } from './style';
import { addCommasToNumber } from '../../../../utils/utility';
import classes from '../../../../styles/globalClasses';
import gs from '../../../../styles/globalStyles';
import { CaretRight } from '../../../../sharedComponents/Icons/Icons';
import Button from '../../../../sharedComponents/Button/Button';
import FadeInAnimation from '../../../../sharedComponents/FadinAnimation/FadinAnimation';
import Info from '../../../../../assets/Icons/Info';
import Typography from '../../../../sharedComponents/typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens,TypographyTypeDLS } from '@voltmoney/schema';
import { checkColor } from '@app/utils';
import { ThemedView } from '@app/theme';
export const SHIMMER_PAGE =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Shimmer_page.png';

export const LimitResultCard = ({
  amount,
  editLimitAction = () => { },
  ctaAction = () => { },
  showEditLimit,
  lastEditDate,
  buttonLoader,
}) => {
  return (
    <FadeInAnimation delay={100} duration={1000}>
      <ThemedView m="lg">
        <ThemedView 
          backgroundColor='bg-surface-primary' 
          p="lg" 
          borderColor='border-primary' 
          borderTopLeftRadius='lg' 
          borderTopRightRadius='lg'
          style={[
            showEditLimit ? styles.headingWhenEditLimitShown : styles.heading
          ]}>
          <Typography
              label={showEditLimit ? "Selected credit limit" : "Available credit limit"}
              fontSize={FontSizeTokens.SM}
              fontWeight={'400'}
              fontFamily={FontFamilyTokens.Inter}
              color={ColorTokens.Grey_Charcoal}
              lineHeight={20}
          />
          <Typography
              label={'₹' + addCommasToNumber(amount)}
              fontSize={FontSizeTokens.XXL}
              fontWeight={'700'}
              fontFamily={FontFamilyTokens.Inter}
              color={ColorTokens.Secondary_100}
              lineHeight={32}
          />
        </ThemedView>
        {showEditLimit ? (
          <View style={styles.subHeadingAndroidIOS}>
            <View
              style={{
                height: 30,
                backgroundColor: '#F1F3F5',
                borderRadius: 6,
                paddingHorizontal: 12,
                flexDirection: 'row',
                marginLeft: 20,
                marginRight: 16,
                marginBottom: 16,
                alignContent: 'center',
                alignItems: 'center',
              }}>
              <Info size={16} color={'rgb(102, 112, 133)'} />
              <View style={{ marginLeft: 8}}>
                <Typography
                    typeDLS={TypographyTypeDLS.B1R}
                    label={`Last checked on ${lastEditDate}`}
                    color={ColorTokens.Grey_Charcoal}
                />
              </View>
            </View>

            <View
              style={{
                flexDirection: 'row',
                alignContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginBottom: 16,
                justifyContent: 'center',
                flex: 1,
                padding: 16,
              }}>
              <View style={{ flex: 0.38, marginRight: 8, height: 32 }}>
                <Button
                  eventName='DASHBOARD_EDIT_LIMIT_CLICKED'
                  size="MD"
                  handlePress={editLimitAction}
                  type="OUTLINED"
                  label={'Edit limit'}
                  showRightAccessory={true}
                  rightAccessory={() => {
                    return (
                      <CaretRight size={16} weight="bold" color={checkColor("#1434cb")} />
                    );
                  }}
                />
              </View>
              <View style={{ flex: 0.62, height: 32 }}>
                {(
                  <Button
                    size="MD"
                    label={'Continue application'}
                    type={'SOLID'}
                    eventName='AFTER_LIMIT_CONTINUE_APPLICATION'
                    showShadow={true}
                    buttonLoader={buttonLoader}
                    handlePress={ctaAction}
                    showRightAccessory={true}
                    rightAccessory={() => {
                      return (
                        <CaretRight size={16} weight="bold" color="#fff" />
                      );
                    }}
                  />
                )}
              </View>
            </View>
          </View>
        ) : (
          <View style={styles.subHeading}>
            <View style={styles.subHeadingContainer}>
              <View style={styles.imageContainer}>
                <Image
                  source={{ uri: SHIMMER_PAGE }}
                  style={styles.shimmerImage}
                />
              </View>
              <View style={styles.textContainer}>
                <Typography
                  label={"You’re almost there!"}
                  fontSize={FontSizeTokens.MD}
                  fontWeight={'600'}
                  fontFamily={FontFamilyTokens.Poppins}
                  color={ColorTokens.Grey_Night}
                  lineHeight={24}
                />
                <Typography
                  label={"Finish application in a few minutes"}
                  fontSize={FontSizeTokens.XS}
                  fontWeight={'400'}
                  fontFamily={FontFamilyTokens.Inter}
                  color={ColorTokens.Grey_Charcoal}
                  lineHeight={18}
                />
              </View>
            </View>
            <View
              style={styles.buttonContainer}
              nativeID="bt_landingScreen_continueApplication">
              <Button
                size="LG"
                label={'Continue application'}
                eventName='AFTER_LIMIT_CONTINUE_APPLICATION'
                type={'SOLID'}
                showShadow={true}
                buttonLoader={buttonLoader}
                handlePress={ctaAction}
              />
            </View>
          </View>
        )}
      </ThemedView>
    </FadeInAnimation>
  );
};
